import dayjs from 'dayjs'
import i18n from '@/plugins/i18n'

export const ledgerSearchFields: any = reactive({
  id: null,
  confirmationId: '',
  description: '',
  amountType: '',
  paymentMethod: '',
  reference: '',
  fromDate: null,
  toDate: null,
  hybridRole: '',
})

export const resetLedgerFields = { ...ledgerSearchFields }

export const hybridRoleOptions = [
  { text: i18n.global.t('Loader'), value: 'loader' },
  { text: i18n.global.t('Trucker'), value: 'trucker' },
]

export const ledgerHeaders = [
  { title: 'No', key: 'id' },
  { title: 'Transaction Date', key: 'date', align: 'start', width: 150 },
  { title: 'CNF ID', key: 'confirmationId', align: 'start' },
  { title: 'Description', key: 'description', align: 'start', width: 200 },
  { title: 'Amount Type', key: 'amountType', align: 'start', width: 100 },
  { title: 'Tran. Type', key: 'paymentMethod', align: 'start' },
  { title: 'Remarks', key: 'reference', align: 'start' },
  { title: 'Receivable', key: 'receivable', align: 'start' },
  { title: 'Received', key: 'received', align: 'start' },
  { title: 'Payable', key: 'payable', align: 'start' },
  { title: 'Paid', key: 'paid', align: 'start' },
  { title: 'Discount', key: 'discount', align: 'start' },
  { title: 'Actions', key: 'actions', sortable: false, align: 'start' },
]

export const openingBalanceType = [
  { text: i18n.global.t('Receivable'), value: 'RECEIVABLE' },
  { text: i18n.global.t('Payable'), value: 'PAYABLE' },
]

export const getDateRanges = (type: string) => {
  const today = dayjs()

  // The books run April to March, the same year boundary the FY… ledger ids are numbered on
  const fiscalYearStart = today.month() < 3
    ? today.subtract(1, 'year').month(3).startOf('month')
    : today.month(3).startOf('month')

  const ranges: any = {
    today: { start: today.format('YYYY-MM-DD'), end: today.format('YYYY-MM-DD') },
    last30: {
      start: today.subtract(29, 'day').format('YYYY-MM-DD'),
      end: today.format('YYYY-MM-DD'),
    },
    last90: {
      start: today.subtract(89, 'day').format('YYYY-MM-DD'),
      end: today.format('YYYY-MM-DD'),
    },
    last180: {
      start: today.subtract(179, 'day').format('YYYY-MM-DD'),
      end: today.format('YYYY-MM-DD'),
    },
    yesterday: {
      start: today.subtract(1, 'day').format('YYYY-MM-DD'),
      end: today.subtract(1, 'day').format('YYYY-MM-DD'),
    },
    thisWeek: {
      start: today.startOf('week').format('YYYY-MM-DD'),
      end: today.format('YYYY-MM-DD'),
    },
    thisMonth: {
      start: today.startOf('month').format('YYYY-MM-DD'),
      end: today.format('YYYY-MM-DD'),
    },
    lastMonth: {
      start: today.subtract(1, 'month').startOf('month').format('YYYY-MM-DD'),
      end: today.subtract(1, 'month').endOf('month').format('YYYY-MM-DD'),
    },
    thisFiscalYear: {
      start: fiscalYearStart.format('YYYY-MM-DD'),
      end: today.format('YYYY-MM-DD'),
    },
    lastFiscalYear: {
      start: fiscalYearStart.subtract(1, 'year').format('YYYY-MM-DD'),
      end: fiscalYearStart.subtract(1, 'day').format('YYYY-MM-DD'),
    },
    all: {
      start: null,
      end: null,
    },
  }

  return ranges[type] || {}
}
